import Unit from './Unit'
import { UnitTypes, BrochureFileNameLocaleKeys } from '@/constants/units'
import ProjectType from '@/classes/ProjectType'

export default class OfficeUnit extends Unit {
  get brochureFileNameLocaleKey() {
    const projectType = new ProjectType()
    return projectType.switcher({
      [projectType.SINGLETOWER_TYPE]:
        BrochureFileNameLocaleKeys.SINGLETOWER_OFFICE,
      [projectType.MULTITOWER_TYPE]:
        BrochureFileNameLocaleKeys.MULTITOWER_OFFICE,
      [projectType.NEIGHBOURHOOD_TYPE]:
        BrochureFileNameLocaleKeys.NEIGHBOURHOOD_OFFICE,
    })
  }
  get type() {
    return UnitTypes.OFFICE
  }
}
